import React, { useState } from "react";
import "./dark.css";

const Dark = () => {
  const [light, setLight] = useState(false);

  const [dark, setDark] = useState(false);
  let clickedClass = "clicked";
  const body = document.body;
  const lightTheme = "light";
  const darkTheme = "dark";
  let theme;

  if (localStorage) {
    theme = localStorage.getItem("theme");
  }

  if (theme === lightTheme || theme === darkTheme) {
    body.classList.add(theme);
  } else {
    body.classList.add(lightTheme);
  }

  const switchTheme = (e) => {
    if (theme === darkTheme) {
      body.classList.replace(darkTheme, lightTheme);
      e.target.classList.remove(clickedClass);
      localStorage.setItem("theme", "light");
      theme = lightTheme;
    } else {
      body.classList.replace(lightTheme, darkTheme);
      e.target.classList.add(clickedClass);
      localStorage.setItem("theme", "dark");
      theme = darkTheme;
    }
  };
  return (
    <>
      <button
        className={theme === "dark" ? clickedClass : ""}
        id="darkMode"
        onClick={(e) => switchTheme(e)}
        style={{background:'transparent', border:'none', color:'white', cursor:'pointer'}}
      >
        <div className="theme-toggle">

            <span
              className="light-toggle"
              onClick={() => {
                setLight(!light);
                setDark(!dark);
              }}
            >
              {light || <i className="ri-sun-fill"></i>}
            </span>
            <span
              className="dark-toggle"
              onClick={() => {
                setLight(!light);
                setDark(!dark);
              }}
            >
              {dark && <i className="ri-moon-fill"></i>}
            </span>

        </div>
      </button>
    </>
  );
};

export default Dark;
